import "@/polyfill";
import App from "@/App";
import BootstrapVue from "bootstrap-vue";
import vSelect from "vue-select";
import Vue from "vue";
import VueBarcodeScanner from "vue-barcode-scanner";
import VueCookies from "vue-cookies";
import Vuex from "vuex";
import VueLodash from "vue-lodash";
import UUID from "vue-uuid";
import lodash from "lodash";
import router from "@/router/index";
import store from "@/store/index";
import "v-calendar/lib/v-calendar.min.css";
Vue.config.productionTip = false;

Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(Vuex);
Vue.use(VueLodash, { name: "custom", lodash });
Vue.use(UUID);
Vue.use(require("vue-faker"));
Vue.use(VueBarcodeScanner);
Vue.use(require("vue-moment"));
Vue.component("v-select", vSelect);
Vue.config.devtools = true;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  }
});
